import type { Icon, IconProps } from "@phosphor-icons/react";
import { useLocale } from "use-intl";

import { getDir } from "@/hooks/useLocaleInfo";

export function addRtlSupport(
  IconComponent: Icon,
): React.ComponentType<IconProps> {
  const PatchedIcon = (props: IconProps) => {
    const locale = useLocale();

    return <IconComponent mirrored={getDir(locale) === "rtl"} {...props} />;
  };

  PatchedIcon.displayName = IconComponent.displayName;

  return PatchedIcon;
}
